import { hooks, blocks, view } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackWidgetDeleted = () => {
  hooks.operations.subscribe(
    hooks.availableHooks.ON_BEFORE_BLOCK_DELETED,
    ({ blockId, variationId: blockVariationId, elementId, constraintId }) => {
      if (!constraintId || (blockId && !blockId.startsWith('widget-'))) {
        return;
      }

      const parentElement = view.accessors.getParentLiveElement(elementId);
      const wsBlockElement = parentElement.closest(`[id^=${blocks.constants.BLOCK_ID_PREFIX}]`);
      const targetBlockId = blocks.accessors.getBlockIdByElement(wsBlockElement);
      const targetBlockVariationId = blocks.accessors.getVariationIdByElement(wsBlockElement);

      trackEvent(constants.events.WIDGET_DELETED, {
        blockId,
        blockVariationId,
        targetBlockId,
        targetBlockVariationId,
        constraintId,
      });
    }
  );
};

export default trackWidgetDeleted;
